/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_CardInputs */



/**
* | output |
* | --- |
* | "Current Card" |
*
* @param {Current_CardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const current_card = /** @type {((inputs?: Current_CardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_CardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Carte actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Karte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carta attuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текущая карта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tarjeta corriente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当前卡")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のカード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान कार्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cartão atual")
	return /** @type {LocalizedString} */ ("Current Card")
});